import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-share-review',
  templateUrl: './share-review.component.html',
  styleUrls: ['./share-review.component.scss']
})
export class ShareReviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
